<template>
  <white-bg style="min-height: 358px;">
    <preload-content :loading="!form">
      <template v-if="form">
        <div class="avatar">
          <div class="camera">
            <a class="camera-visible" @click="$refs.avatar.click()">
              <img src="../../../../assets/images/icons/camera-setting.svg" alt="Изменить">
            </a>
            <img :src="avatar" v-if="avatar">
            <input hidden type="file" @change="setAvatar" ref="avatar">
          </div>
          <error-text :text="errors.avatar"/>
        </div>
        <div class="settings-input">
          <div class="params">Имя</div>
          <input :disabled="form.authorized_at" type="text" v-model="form.name" @change="errors.name = null">
          <error-text :text="errors.name"/>
        </div>
        <div class="settings-input">
          <div class="params">Фамилия</div>
          <input :disabled="form.authorized_at" type="text" v-model="form.surname" @change="errors.surname = null">
          <error-text :text="errors.surname"/>
        </div>
        <div class="settings-input">
          <div class="params">Телефон</div>
          <input :disabled="true" type="text" v-model="form.phone">
          <error-text :text="errors.phone"/>
        </div>
        <div class="settings-input">
          <div class="params">Почта</div>
          <input type="text" v-model="form.email" @change="errors.email = null">
          <error-text :text="errors.email"/>
        </div>
        <div class="settings-input">
          <custom-checkbox v-model="form.is_chat_notify">Уведомлять о новом сообщении?</custom-checkbox>
          <error-text :text="errors.is_chat_notify"/>
        </div>
        <div class="settings-input">
          <custom-checkbox v-model="form.can_call_me">Клиенты могут мне звонить в чате?</custom-checkbox>
          <error-text :text="errors.can_call_me"/>
        </div>

        <div style="margin-bottom: 10px" class="params">Связь со мной:</div>
        <div class="settings-input">
          <custom-checkbox v-model="form.call">Звонок на телефон</custom-checkbox>
          <error-text :text="errors.call"/>
        </div>
        <div class="settings-input">
          <custom-checkbox v-model="form.viber">Доступен в Viber</custom-checkbox>
          <error-text :text="errors.viber"/>
        </div>
        <div class="settings-input">
          <custom-checkbox v-model="form.whatsapp">Доступен в WhatsApp</custom-checkbox>
          <error-text :text="errors.whatsapp"/>
        </div>
        <div class="settings-input">
          <div class="params">Ник в telegram</div>
          <input type="text" v-model="form.telegram" @change="errors.telegram = null">
          <error-text :text="errors.telegram"/>
        </div>


        <button-component variant="filled" @click="update" :loading="loading">Сохранить</button-component>
      </template>
    </preload-content>
  </white-bg>
</template>

<script>
import ButtonComponent from '@/components/ui/buttons/button-component';
import preloadContent from '../../../../components/ui/preload-content';
import WhiteBg from '../../../../components/ui/white-bg';
import ErrorText from '../../../../components/ui/text/error-text';
import {mapGetters, mapMutations} from "vuex";
import CustomCheckbox from '../../../../components/ui/inputs/custom-checkbox'

export default {
  name: "General",
  components: {CustomCheckbox, WhiteBg, ErrorText, preloadContent, ButtonComponent},
  data() {
    return {
      avatar: null,
      form: null,
      errors: {},
      loading: false,
    }
  },
  created() {
    this.setForm(this.getUser);
  },
  computed: mapGetters(['getUser']),
  methods: {
    ...mapMutations(['setUser']),
    setForm(data) {
      let form = Object.assign({}, data);
      this.form = form;
      this.avatar = form.avatar;
      this.form.avatar = null;
    },
    setAvatar(event) {
      this.errors.avatar = null;
      let instance = this;
      Array.from(event.target.files).forEach((image) => {
        if (!image.type.match('image.*')) return;
        let reader = new FileReader();
        reader.onload = (() => {
          return (e) => instance.avatar = e.target.result;
        })(image);
        reader.readAsDataURL(image);
        instance.form.avatar = image;
      });
    },
    update() {
      this.loading = true;
      let form = Object.assign({}, this.form);
      form.is_chat_notify = this.form.is_chat_notify ? 1 : 0;
      this.$api.master.update(form).then(({data}) => {
        this.setUser(data);
        this.setForm(data);
        this.errors = {};
        this.$toast.success('Сохранено!');
      }).catch(({response}) => this.errors = response.data.errors)
          .finally(() => this.loading = false);
    },
  }
}
</script>

<style scoped lang="scss">
h3 {
  padding-bottom: 0;
}

.settings {
  padding: 30px 30px 0 30px;

  &__top {
    padding-bottom: 30px;

    h3 {
      font-weight: 600;
      font-size: 20px;
      line-height: 28px;
      color: #383838;
      padding-bottom: 20px;
    }
  }

  &__bottom {
    padding: 30px -15px 0 0;
    border-top: 1px solid #E5E5E5;
    display: flex;

    &-prices {
      width: 100%;
      display: flex;
      justify-content: space-between;

      .close {
        height: 50px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: flex-end;
      }

      h3 {
        padding-bottom: 0;
        display: flex;
        align-items: center;
        justify-content: flex-start;
      }

      button {
        margin-top: 0;
        width: auto;
        font-weight: 600;
        font-size: 16px;
        line-height: 1.4;
        color: #B9765B;
        background-color: transparent;
        border: none;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        padding: 0 0;

        &:before {
          content: '';
          width: 20px;
          height: 20px;
          margin-right: 5px;
          background-image: url("../../../../assets/images/icons/edit.svg");
          background-position: center center;
          background-size: contain;
        }
      }
    }
  }

  &__services {
    padding-bottom: 10px;

    h3 {
      padding-top: 15px;
    }

    button {
      visibility: visible;
      height: 20px;
      margin-top: 0;
      width: auto;
      font-weight: 600;
      font-size: 16px;
      line-height: 1.4;
      color: #B9765B;
      background-color: transparent;
      border: none;
      cursor: pointer;
      display: flex;
      align-items: center;
      padding: 10px 0 25px 0;

      &:before {
        content: '';
        width: 20px;
        height: 20px;
        margin-right: 5px;
        background-image: url("../../../../assets/images/icons/edit.svg");
        background-position: center center;
        background-size: contain;
      }
    }
  }
}

.select {
  height: 37.5px;
  width: 100%;
  max-width: unset;
  margin-bottom: 20px;
}

button {
  width: 100%;
  height: 50px;
  border: none;
  background: #DBBFA7;
  border-radius: 5px;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  color: #383838;
  margin-top: 15px;
}

.avatar {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 20px;

  .camera {
    position: relative;
    width: 100px;
    height: 100px;
    border-radius: 50%;

    &:hover .camera-visible {
      visibility: visible;
    }

    .camera-visible {
      visibility: hidden;
      position: absolute;
      background: rgba(56, 56, 56, 0.70);
      width: 100px;
      height: 100px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 50%;

      img {
        width: 37.95px;
        height: 30.8px;
        border-radius: unset;
      }
    }
  }

  img {
    width: 100px;
    height: 100px;
    border-radius: 50%;
    object-fit: cover;
  }
}

h3 {
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  color: #383838;
  padding-bottom: 0;
}

.params {
  padding-left: 10px;
  font-weight: 600;
  font-size: 12px;
  line-height: 20px;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: #808080;
  font-family: "Open Sans", sans-serif;
}

.settings-input {
  position: relative;
  width: 100%;
  margin-bottom: 20px;

  input {
    font-family: "Open Sans", sans-serif;
    width: 100%;
    height: 37.5px;
    background: #FFFFFF;
    border: 1px solid #DBBFA7;
    border-radius: 5px;
    padding-left: 20px;
    color: #383838;
    font-size: 16px;

    &::placeholder {
      font-size: 16px;
      line-height: 24px;
      color: #808080;
    }
  }

  button {
    margin-top: 10px;
    width: 20px;
    height: 20px;
    position: absolute;
    right: 15px;
    top: 50%;
    transform: translateY(-50%);
    background-color: transparent;
    border: none;
    background-image: url('../../../../assets/images/icons/eye-off.svg');
    background-position: center center;
    background-repeat: no-repeat;
    background-size: contain;
    cursor: pointer;
  }
}

input:disabled {
  background-color: #dbbfa7 !important;
  position: relative;
  background-image: url("/lock-solid.svg") !important;
  background-repeat: no-repeat !important;
  background-position: bottom 12px right 10px;
  background-size: 12px;
}

@media screen and (max-width: 1170px) {
  .whiteBg {
    margin: 0 -15px !important;
  }
}
</style>
